const HomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
  >
    <path
      d="M6.72766 5.15008C6.72766 4.47653 6.18164 3.93051 5.5081 3.93051C4.83455 3.93051 4.28853 4.47653 4.28853 5.15008V14.0133C3.55948 14.4351 3.06897 15.2233 3.06897 16.1262C3.06897 17.029 3.55948 17.8172 4.28853 18.239V19.7848C4.28853 20.4584 4.83455 21.0044 5.5081 21.0044C6.18164 21.0044 6.72766 20.4584 6.72766 19.7848V18.239C7.45672 17.8172 7.94723 17.029 7.94723 16.1262C7.94723 15.2233 7.45672 14.4351 6.72766 14.0133V5.15008Z"
      fill="white"
    />
    <path
      d="M14.045 5.15008C14.045 4.47653 13.499 3.93051 12.8255 3.93051C12.1519 3.93051 11.6059 4.47653 11.6059 5.15008V6.69595C10.8769 7.11769 10.3864 7.90595 10.3864 8.80877C10.3864 9.71159 10.8769 10.4998 11.6059 10.9216V19.7848C11.6059 20.4584 12.1519 21.0044 12.8255 21.0044C13.499 21.0044 14.045 20.4584 14.045 19.7848V10.9216C14.7741 10.4998 15.2646 9.71159 15.2646 8.80877C15.2646 7.90595 14.7741 7.11769 14.045 6.69595V5.15008Z"
      fill="white"
    />
    <path
      d="M20.1429 3.93051C20.8164 3.93051 21.3624 4.47653 21.3624 5.15008V14.0133C22.0915 14.4351 22.582 15.2233 22.582 16.1262C22.582 17.029 22.0915 17.8172 21.3624 18.239V19.7848C21.3624 20.4584 20.8164 21.0044 20.1429 21.0044C19.4693 21.0044 18.9233 20.4584 18.9233 19.7848V18.239C18.1942 17.8172 17.7037 17.029 17.7037 16.1262C17.7037 15.2233 18.1942 14.4351 18.9233 14.0133V5.15008C18.9233 4.47653 19.4693 3.93051 20.1429 3.93051Z"
      fill="white"
    />
  </svg>
);

export default HomeIcon;
